import React, { useEffect, useState } from "react";
import {
  TableHead,
  TableBody,
  Table,
  TableContainer,
  TableCell,
  TableRow,
  Box,
  Pagination,
  Button,
  FormControl,
  Autocomplete,
  TextField,
  Typography,
  Select, 
  InputLabel,
  MenuItem,
} from "@mui/material";
import {
  loanRequestOnly,
  loanRequest,
  listLoanSubProducts,
  loanDisbursementConfirmation,
  commonRunQuery,
  loanRequestOnlyDynamic
} from "../../util/API/loans";
import CustomForm from "../UI/CustomForm/CustomForm";
import { useDispatch } from "react-redux";
import { setNewConstants } from "../../store/redux/constants";
import CustomLoansForm from "../UI/CustomLoansForm/CustomLoansForm";
import LoadingPage from "../UI/LoadingPage/LoadingPage";

const LoanCreateNew = ({setCreateNewLoan, selectedProductLoan, maxAmtInputError, setAlert, selectedUser, selectedProductLoanId, selectedCurrencyCode, loanType, getProductsAssignedToUsers, setAlertOpen, selectedLoanProductArray, selectedProductEligiblity}) => {
  const [loanAmt, setLoanAmt] = useState("");
  const [loanSubProducts, setLoanSubProducts] = useState([]);
  const [selectedLoanSubProducts, setSelectedLoanSubProducts] = useState(null);
  const [termType, setTermType] = useState("");
  const [showTermType, setShowTermType] = useState(false);
  const [loanTerms, setLoanTerms] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [formValues, setFormValues] = useState({
    selectproduct: loanSubProducts
  });

  const dispatch = useDispatch();

  console.log("selectedProductLoan=========",selectedProductLoan);
  console.log("selectedProductLoanId=========",selectedProductLoanId);
  console.log("loanType=========",loanType);
  console.log("selectedLoanProductArray=========",selectedLoanProductArray);
  console.log("LoanCreateNew_selectedProductEligiblity=========",selectedProductEligiblity);
  
  useEffect(()=> {
    getLoanProducts();
  },[])

  useEffect(()=> {
    dispatch(setNewConstants({ formSelectData: { selectproduct: loanSubProducts } }));

    if(loanTerms.length > 0) {
      dispatch(setNewConstants({ formSelectData: { selectproduct: loanSubProducts, termtype: loanTerms  } }));
    }
  },[loanSubProducts, showTermType])

  const getLoanProducts = async() => {
    try {
      const response = await listLoanSubProducts(227, selectedProductLoanId);

      if ( response?.data?.header?.callStatus === "1" && response?.data?.header?.reccount !== "0" ) {
          console.log("getLoanProducts_response=========------------------",response?.data?.body?.record);
          const loanProductsArray = Array.isArray(response?.data?.body?.record)
            ? response?.data?.body?.record
            : [response?.data?.body?.record];
          
          // Removing any entries that may have selectablebyuser:"0"
          const filteredArray = loanProductsArray.filter(
            (item) => item.loantypes.selectablebyuser !== "0"
          );
          
          console.log("filteredArray=========------------------",filteredArray);

          const formatedArr = filteredArray.map((item, index) => ({
          // const formatedArr = loanProductsArray.map((item, index) => ({
            key: item.loantypes.loantype,
            value: item.loantypes.loantype,
            label: item.loantypes.loandesc,
          }));
          setLoanSubProducts(formatedArr);
          console.log("loanProductsArray=========",formatedArr);
      }
    } catch (error) {
      console.log("getLoanProducts_error=========",error);
      
    } finally {
      setIsLoading(false);
    }
  }

  const handleLoanAmtChange = (e) => {
    setLoanAmt(e?.target?.value);
  };

  const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

  const handleCreateNewLoan = async (submittedData) => {
    setIsLoading(true);
    console.log("submittedData-------------", submittedData);
    console.log("selectedLoanSubProducts-------------", selectedLoanSubProducts);
    console.log("loanAmt-------------", loanAmt);
    console.log("currency-------------", selectedProductLoanId);
    try {
      if(JSON.parse(submittedData?.loanamount) > JSON.parse(selectedProductEligiblity) ) {
        setAlert({
          showAlert: true,
          severity: "error",
          message: "Loan amount exceeds loan eligiblity.",
          header: "Error!",
        });
        
        return false;
      }
      // let response = await loanRequestOnly( "", selectedUser, selectedProductLoanId, selectedLoanSubProducts, submittedData?.loanamount, 1, 1, 0 );
      // let response = await loanRequestOnly( "", selectedUser, selectedLoanSubProducts?.value, 1, loanAmt, 1, 1, 0 );
      let response = await loanRequestOnlyDynamic( "", selectedUser, selectedProductLoanId, selectedLoanSubProducts, submittedData?.loanamount, 1, 1, 0, selectedLoanProductArray?.autoapprove == "0" ? 6 : -2 );

      if (response?.data?.header?.callStatus === "1") {
        getProductsAssignedToUsers()
        setAlert({
          showAlert: true,
          severity: "success",
          message: "Loan request submitted successfully.",
          header: "Congratulations!",
        });

        if(selectedLoanProductArray?.autoapprove != "0") {
          await delay(3000);
        }
        
        setAlertOpen(true);
      }

      setCreateNewLoan(false);
      setLoanAmt("");
      console.log("handleCreateNewLoan_responseeeee-------------", response);
    } catch (error) {
      console.log("handleCreateNewLoan_error-------------", error);
      setIsLoading(false);
    } finally {
      setIsLoading(false);
    }
  };

  const handleCreateNewRealTimeLoan = async(submittedData) => {
    try {
      setIsLoading(true);
      const response = await loanRequest( "", selectedUser, selectedProductLoanId, selectedLoanSubProducts, submittedData?.loanamount, 1, 1, 0, "", 1, "", "", submittedData?.termtype == "" ? "0" : submittedData?.termtype, 1);
      
      if (response?.data?.header?.callStatus === "1") {
        const loanDisbursementRes = await loanDisbursementConfirmation("", response?.data?.header?.userid, response?.data?.header?.loanid )
        console.log("loanDisbursementConfirmation_response-------------", loanDisbursementRes);
        getProductsAssignedToUsers();
        setAlert({
          showAlert: true,
          severity: "success",
          message: "Loan created successfully.",
          header: "Congratulations!",
        });
        setAlertOpen(true);
      } else if(response?.Status == "2"){
        if(response?.payload?.callStatus == "0") {
          console.log("handleCreateNewLoan_error(0)-------------", response);
          console.log("handleCreateNewLoan_error(0)_msg-------------", response?.payload?.msg);
          setAlert({
            showAlert: true,
            severity: "error",
            message: `${response?.payload?.msg}` ,
            header: "Failed to create Loan!",
          });
        }
        if(response?.payload?.callStatus == "-1") {
          console.log("handleCreateNewLoan_error(-1)-------------", response);
          setAlert({
            showAlert: true,
            severity: "error",
            message: "Failed to create Loan.",
            header: "Error!",
          });
        }
      }

      console.log("handleCreateNewLoan_responseeeee-------------", response);
      setCreateNewLoan(false);
      setLoanAmt("");
    } catch (error) {
      setIsLoading(false);
      console.log("handleCreateNewRealTimeLoan_error----------",error);
    } finally {
      setIsLoading(false);
    }
  }

  const handleLoanSubProductChange = async(name, value) => {
    console.log("handleLoanSubProductChange----------",name);
    console.log("handleLoanSubProductChange----------",value);
    setSelectedLoanSubProducts(value);
    
    try {
      const response = await commonRunQuery(242, value);
      
      if ( response?.data?.header?.callStatus === "1" && response?.data?.header?.reccount !== "0" ) {
        const termsArray = Array.isArray(response?.data?.body?.record)
        ? response?.data?.body?.record
        : [response?.data?.body?.record];
        
        
        const formatedArr = termsArray.map((item, index) => ({
          key: item.vloantypepaymentterms.planterm,
          value: item.vloantypepaymentterms.planterm,
          label: item.vloantypepaymentterms.plandesc,
        }));
        console.log("formatedArr=========------------------",formatedArr);
        setLoanTerms(formatedArr);
        setShowTermType(true);
      } else {
        setShowTermType(false);
        setLoanTerms([]);
      }
    } catch (error) {
      console.log("getLoanProducts_error=========",error);
    }
  }

  const handleTermTypeChange = (e) => {
    console.log("e-----------",e.target.value);
    setTermType(e.target.value);
  };

  // if (isLoading) {
  //   return <LoadingPage />;
  // }

  return (
    <>
      {
        isLoading ? 
        (
          <div className="text-center mt-5">
              <span className="loader" />
          </div>
      ):
        <Box>
          <Box className="d-flex justify-content-between">
            <Typography
              sx={{
                fontFamily: "'Nunito'",
                fontStyle: "normal",
                fontWeight: 500,
                fontSize: "21.4825px",
                color: "#3A3A3A",
              }}
              className=""
            >
              {loanType === "approval" ? "Create New Approval Loan" : "Create New Real Time Loan"}
            </Typography>

            <Button
                className="fs-size-12 paiy-blue text-white"
                variant="contained"
                color="primary"
                onClick={() => {
                  setCreateNewLoan(false);
                  handleLoanAmtChange("")
                }}
              >
                Return
            </Button>
          </Box>

          <Box className="mt-4">
            {/* <FormControl
              sx={{
                borderRadius: "4px",
                display: "flex",
                flexDirection: "column",
                width: "100%",
                margin: "auto",
                marginBottom: "7px",
              }}
              className=""
            >
              <Typography
                sx={{
                  fontFamily: "'Nunito'",
                  fontStyle: "normal",
                  fontWeight: 400,
                  fontSize: "1rem",
                  // color: "#3A3A3A",
                }}
                className="mb-2"
              >
                <span className="">Loan Product:</span> {selectedProductLoan}
              </Typography>
              <Autocomplete
                options={loanSubProducts}
                getOptionLabel={(option) => option.label || ""}
                required="true"
                style={{
                  width: "100%",
                  paddingRight: "0px",
                  paddingLeft: "0px",
                }}
                value={
                  loanSubProducts.length > 0 &&
                  loanSubProducts?.find(
                    (option) => option?.value === selectedLoanSubProducts?.value
                  )
                }
                onChange={(event, newValue) =>
                  handleLoanSubProductChange(event, newValue)
                }
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label={"Select Product"}
                    required={true}
                    sx={{
                      width: "100%",
                      borderRadius: "4px",
                      fontFamily: "Inter",
                      fontSize: "10px",
                      background: "white",
                      marginBottom: "4px",
                      "& .MuiInputBase-root": {
                        maxHeight: "40px",
                        padding: "6px 10px",
                        fontSize: "12px", // Reduced font size of input text
                      },
                    }}
                    InputLabelProps={{
                      style: {
                        fontSize: "12px",
                        textAlign: "center",
                      },
                    }}
                  />
                )}
                disabled={false}
                sx={{
                  width: "100%",
                  borderRadius: "4px",
                  fontFamily: "Inter",
                  fontSize: "12px",
                  background: "white",
                }}
                fullWidth
              />

              <TextField
                // ref={ref}
                className="mt-2"
                label="Loan Amount"
                type="number"
                variant="outlined"
                value={loanAmt}
                InputLabelProps={{ shrink: true, style: { fontSize: "12px" } }}
                onChange={handleLoanAmtChange}
                error={maxAmtInputError}
                sx={{
                  width: "100%",
                  borderRadius: "4px",
                  fontFamily: "Inter",
                  fontSize: "12px",
                  background: "white",
                  paddingTop: "0px",
                  paddingBottom: "0px",
                  marginBottom: "4px",
                  marginTop: "0px",
                  "& .MuiInputBase-root": {
                    maxHeight: "40px",
                    fontSize: "12px",
                  },
                }}
                style={{ paddingTop: "0px", paddingBottom: "0px" }}
              />

              {
                loanType !== "approval" && showTermType &&
                <FormControl sx={{ width: "100%", marginBottom: "10px" }} className="mt-2">
                  <InputLabel sx={{ fontSize: "12px" }}>Term Type</InputLabel>
                  <Select
                    value={termType}
                    onChange={handleTermTypeChange}
                    label="Term Type"
                    sx={{
                      fontSize: "12px",
                      background: "white",
                      "& .MuiInputBase-root": {
                        maxHeight: "40px",
                      },
                    }}
                  >
                    {
                      loanTerms && loanTerms.length>0 && loanTerms.map((val, idx)=> {
                        console.log("Val---------",val)
                        return (
                          <MenuItem value={val?.value}>{val?.label}</MenuItem>
                        )
                      })
                    }
                  </Select>
                </FormControl>
              }
            </FormControl> */}

            <CustomLoansForm
              formValues={formValues}
              formName={"createrealtimeloan"}
              buttonText={"Submit"}
              onSubmit={loanType === "approval" ? handleCreateNewLoan : handleCreateNewRealTimeLoan}
              loadingButtonText={"Adding Card ..."}
              handleLoanSubProductChange={handleLoanSubProductChange}
              loanTerms={loanTerms}
              loanType={loanType}
            />

            {/* <Box className="d-flex gap-3">
              <Button
                className="fs-size-12 paiy-blue text-white"
                variant="contained"
                color="primary"
                onClick={() => {
                  setCreateNewLoan(false);
                  handleLoanAmtChange("")
                }}
              >
                Return
              </Button>

              <Button
                className="fs-size-12 paiy-green text-white"
                variant="contained"
                disabled={isLoading ? true : false}
                // color="success"
                onClick={loanType === "approval" ? handleCreateNewLoan : handleCreateNewRealTimeLoan}
              >
                {isLoading ? "Loading..." : "Create New Loan"}
              </Button>
            </Box> */}
          </Box>
        </Box>
      }
    </>
  )
}

export default LoanCreateNew;
